import React, { lazy, Suspense, useContext, useState } from 'react';
import { ApolloProvider, ApolloClient, createHttpLink, InMemoryCache, from } from '@apollo/client';
import { BrowserRouter, HashRouter, Switch, Route, Redirect } from "react-router-dom";
import { makeVar } from '@apollo/client';
import { QueryParamProvider } from "use-query-params";
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import apolloLogger from 'apollo-link-logger';
import { createUploadLink } from 'apollo-upload-client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import SubscriptionForm from "./components/SubscriptionForm";

const CAPTCHA_SITE_KEY = '6Le2fe0ZAAAAAGET_z5dPIYTuuzuSZWIbQYIiLYf';
export const AppContext: any = React.createContext(null);
export const useAppConfigValue = () => useContext(AppContext);

const Routes = () => {
  return (<Switch>
    <Route exact path="/"><Redirect to="/subscribe" /></Route>
    <Route path="/subscribe/:defaultOfferId?" component={SubscriptionForm} />
  </Switch>);
}
function App({ embed = false, config}) {
  const {  graphqlendpoint, publicationname, authnetclientkey, authnetapiloginid, termsandconditionsurl, privacypolicyurl } = config
  console.log("config values", config);
  const url = new URL('/pre1/graphql', window.location.href);
  const uri = process.env.NODE_ENV == "development" ? "http://localhost:4000/graphql" : (graphqlendpoint ? graphqlendpoint : url.href);
  const httpLink = createUploadLink({ uri });
  const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('access_token');
    if (token) headers.authorization = `Bearer ${token}`;
    return { headers }
  });
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) graphQLErrors.forEach(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`));
    if (networkError) console.log(`[Network error]: ${networkError}`);
  });
  const cache = new InMemoryCache();
  const link = from([
    authLink,
    apolloLogger,
    errorLink,
    httpLink
  ]);
  const client = new ApolloClient({
    cache,
    link,
    name: 'smartpublisher_com',
    version: '1.0'
  });
  return (
    <AppContext.Provider value={config}>
      <QueryParamProvider>
        <ApolloProvider client={client}>
          <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_SITE_KEY}>
            <Suspense fallback={<div></div>}>
              {embed ? <HashRouter><Routes></Routes></HashRouter> : <BrowserRouter><Routes></Routes></BrowserRouter>}
            </Suspense>
          </GoogleReCaptchaProvider>
        </ApolloProvider>
      </QueryParamProvider>
    </AppContext.Provider>
  );
}

export default App;
